export { LoginPage as default } from '@eneco/components-next/auth';
